// PostHog — gracefully no-op when REACT_APP_POSTHOG_KEY is missing.
import posthog from "posthog-js";

let ready = false;

export function initPostHog() {
    const key = process.env.REACT_APP_POSTHOG_KEY;
    if (!key) return;
    try {
        posthog.init(key, {
            api_host: process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com",
            person_profiles: "identified_only",
            capture_pageview: true,
            autocapture: true,
            disable_session_recording: true,
        });
        ready = true;
    } catch (e) {
        // never break the app for telemetry
        console.warn("[posthog] init failed", e);
    }
}

export function phIdentify(userId, props) {
    if (!ready) return;
    try { posthog.identify(userId, props); } catch (e) { console.debug("[posthog] identify failed:", e?.message || e); }
}

export function phCapture(event, props) {
    if (!ready) return;
    try { posthog.capture(event, props); } catch (e) { console.debug("[posthog] capture failed:", e?.message || e); }
}

export function phReset() {
    if (!ready) return;
    try { posthog.reset(); } catch (e) { console.debug("[posthog] reset failed:", e?.message || e); }
}
